module.exports = __webpack_public_path__ + "img/logo-standard-min.5bfc5cde.png";